import React from "react";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import DataGrid, { Column, Paging, Pager } from "devextreme-react/data-grid";
import { Button } from "devextreme-react";
import UserInfo from "../UserInfo";
import notify from "devextreme/ui/notify";
import { criarMotivoIsencaoIptuDs } from "../DataSources.js";

const template = {
  data: new Date(),
  tipoProcesso: 0,
  contribuintes: undefined,
  receitas: undefined,
  motivo: undefined,
  fundamentoLegal: undefined,
  somenteDocumento: 0,
  consolidarLancamento: 0,
  vencimentoConsolidacao: 0,
  inscreverEncargos: 0,
  tipoPeriodo: 1,
  periodo: undefined,
  tipoValor: 0,
  valorMaximoCredito: undefined,
  valorMaximoContribuinte: undefined,
};

export default class ProcedimentoDiat extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...template, previsaoGrade: [] };

    this._gridInstance = React.createRef();
    this.executar = this.executar.bind(this);
    this.gerarPrevisao = this.gerarPrevisao.bind(this);
    this.imprimirPrevisao = this.imprimirPrevisao.bind(this);
    this.salvarPrevisao = this.salvarPrevisao.bind(this);
    this.motivoIsencaoIptuDs = criarMotivoIsencaoIptuDs();

    this.tipoProcessoOptions = {
      dataSource: [
        { id: 0, descricao: "Nenhum" },
        { id: 1, descricao: "Inscrição" },
        { id: 2, descricao: "Remissão" },
        { id: 3, descricao: "Cancelamento" },
        { id: 4, descricao: "Prescrição" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.setState({ tipoProcesso: e.value }),
    };

    this.simNaoOptions = {
      dataSource: [
        { id: 0, descricao: "Não" },
        { id: 1, descricao: "Sim" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.vencimentoOptions = {
      dataSource: [
        { id: 0, descricao: "Nenhum" },
        { id: 1, descricao: "Primeira Parcela" },
        { id: 2, descricao: "Última Parcela" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoPeriodoOptions = {
      dataSource: [
        { id: 0, descricao: "Nenhum" },
        { id: 1, descricao: "Vencimento Original" },
        { id: 2, descricao: "Última Parcela" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoValorOptions = {
      dataSource: [
        { id: 0, descricao: "Nenhum" },
        { id: 1, descricao: "Por Crédito" },
        { id: 2, descricao: "Consolidado por Lançamento" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.motivoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: this.motivoIsencaoIptuDs,
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    this.setState({ ...template });
  }

  executar() {
    return notify("Executando...", "success", 1000);
  }

  gerarPrevisao() {
    return notify("Gerando...", "success", 1000);
  }

  imprimirPrevisao() {
    return notify("Imprimindo...", "success", 1000);
  }

  salvarPrevisao() {
    return notify("Salvando...", "success", 1000);
  }

  render() {
    return (
      <React.Fragment>
        <h3 style={{ marginLeft: "5%" }}>Procedimento de Dívida Ativa</h3>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form
              formData={this.state}
              colCount={1}
              ref={this.formRef}
              labelLocation="top"
              onFieldDataChanged={this.formFieldDataChanged}
            >
              <GroupItem caption="DADOS GERAIS" colSpan={3} colCount={3}>
                <SimpleItem
                  editorType={"dxDateBox"}
                  dataField="data"
                  editorOptions={{
                    width: "100%",
                  }}
                  disabled={!UserInfo.possuiSubPerfil("adm")}
                ></SimpleItem>
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="tipoProcesso"
                  editorOptions={this.tipoProcessoOptions}
                >
                  <Label text="Tipo de Processo" />
                </SimpleItem>
                <SimpleItem
                  dataField="motivo"
                  editorType={"dxLookup"}
                  editorOptions={this.motivoOptions}
                />
                <SimpleItem
                  colSpan={3}
                  editorType={"dxTextArea"}
                  dataField="contribuintes"
                  editorOptions={{ height: "100px" }}
                />
                <SimpleItem
                  colSpan={3}
                  editorType={"dxTextArea"}
                  dataField="receitas"
                  editorOptions={{ height: "100px" }}
                />
                <SimpleItem
                  colSpan={3}
                  editorType={"dxTextArea"}
                  dataField="fundamentoLegal"
                  editorOptions={{ height: "100px" }}
                />
              </GroupItem>

              <GroupItem
                caption="INFORMAÇÕES PARA INSCRIÇÃO DO CRÉDITO"
                colSpan={2}
                colCount={4}
                visible={this.state.tipoProcesso === 1}
              >
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="somenteDocumento"
                  editorOptions={this.simNaoOptions}
                  caption="Somente com Documento"
                />
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="consolidarLancamento"
                  editorOptions={this.simNaoOptions}
                >
                  <Label text="Consolidar por Lançamento" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="vencimentoConsolidacao"
                  editorOptions={this.vencimentoOptions}
                >
                  <Label text="Vencimento da Consolidção" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="inscreverEncargos"
                  editorOptions={this.simNaoOptions}
                />
              </GroupItem>
              {this.state.tipoProcesso}
              <GroupItem
                caption="INFORMAÇÕES PARA EXTINÇÃO DO CRÉDITO"
                colSpan={2}
                colCount={4}
                visible={
                  this.state.tipoProcesso != 1 && this.state.tipoProcesso != 0
                }
              >
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="tipoPeriodo"
                  editorOptions={this.tipoPeriodoOptions}
                >
                  <Label text="Tipo Período" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxSelectBox"}
                  dataField="tipoValor"
                  editorOptions={this.tipoValorOptions}
                >
                  <Label text="Tipo de Valor" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxNumberBox"}
                  dataField="valorMaximoCredito"
                  editorOptions={{ format: uiInfo.formatoNumerico.moeda }}
                >
                  <Label text="Valor Máximo de Credito" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxNumberBox"}
                  dataField="valorMaximoContribuinte"
                  editorOptions={{ format: uiInfo.formatoNumerico.moeda }}
                >
                  <Label text="Valor Máximo por Contribuinte" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Executar"
                  type="success"
                  onClick={this.executar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Gerar Previsão" onClick={this.gerarPrevisao} />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Imprimir Previsão"
                  onClick={this.imprimirPrevisao}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Salvar Previsão" onClick={this.salvarPrevisao} />
              </div>
            </div>
          </form>

          <br />
          <br />
          <PaginaToolbar titulo="Previsão" ocultarNovo={true}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.previsaoGrade}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={false}
              allowColumnReordering={true}
            >
              <Column
                dataField={"tipoProcesso"}
                caption={"Tipo"}
                showInColumnChooser={false}
              />
              <Column
                dataField={"codCredito"}
                caption={"Cód. Crédito"}
                showInColumnChooser={false}
              />
              <Column dataField={"origem"} showInColumnChooser={false} />
              <Column dataField={"contribuinte"} showInColumnChooser={false} />
              <Column
                dataField={"cpfCnpj"}
                caption={"CPF/CNPJ"}
                showInColumnChooser={false}
              />
              <Column
                dataField={"quantidade"}
                caption={"Qtde."}
                showInColumnChooser={false}
              />
              <Column dataField={"vencimento"} showInColumnChooser={false} />
              <Column dataField={"principal"} showInColumnChooser={false} />
              <Column dataField={"juros"} showInColumnChooser={false} />
              <Column dataField={"multa"} showInColumnChooser={false} />
              <Column
                dataField={"correcao"}
                caption={"Correção"}
                showInColumnChooser={false}
              />
              <Column dataField={"total"} showInColumnChooser={false} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }
}
